import { Plugin } from 'prosemirror-state';

import { AddMenuCheckList } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import { NODE_NAME } from '../consts';

function plugins({ t }: EditorOptions) {
  return [
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.check_list.title') as string,
            description: t('Lygo:Menu.check_list.description') as string,
            icon: AddMenuCheckList,
            addMenuIcon: AddMenuCheckList,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['check', 'list', 'task'],
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
